import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { MINUS, SPACE } from '../utils/frfr-string-consts';
import { ROUNDDOWN } from '../utils/excel-functions-utils';
import { _derivatModulProfil_extract_50_ili_70_by_vrstaprofila } from './ter-derivat-lib-terkk-uni-dimenzije';
import { protobomp_manipulator } from '../utils/frfr-protobomp-utils';
import { terProtobompUtils_make_protobomp_manifest_terkk_latest, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_PROFIL } from './ter-protobomp-utils';
import { terUtilsNumberRoundUp, terUtils_get_naziv_materijala_by_ident } from './ter-utils';
import { _getParamsFromLibMaterijalLimParams } from './ter-materijal-utils';
import { js_utils } from '../utils/frfr-js-utils';


/*
TODO


*/


export const derDraftel_terkk_rammraztermostata_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  /*
    ..._pods_input_obj_arr_make(
      // rammraztermostata
      "tipkomore",
      "ksirinaoznaka",
      "kvisinaoznaka",
      "vrstaprofila",
    ),
    ..._pods_input_obj_arr_make(
      // klizacramamraztermostata
      "tipkomore",
      "msirinaunutrasnjaizmedjupregradnih",
    ),
  */
  const pods_input_inherited = {
    // draftel_codecs_pack_terkk$_bundle_rammraztermostata.default_pods_input_state(),

    // rammraztermostata
    tipkomore: virtel_k.tipkomore,
    vrstaprofila: virtel_m.vrstaprofila,
    // ksirinaoznaka: virtel_k.ksirinaoznaka, // NE TREBA
    // kvisinaoznaka: virtel_k.kvisinaoznaka, // NE TREBA

    // klizacramamraztermostata
    // msirinaunutrasnjaizmedjupregradnih: virtel_m.msirinaunutrasnjaizmedjupregradnih, // NE TREBA
    msirinaunutrasnjaizmedjupregradnih: virtel_m.msirinaunutrasnjaizmedjupregradnih, // IPAK TREBA
    // msirinaunutrasnjaizmedjukrilaca: virtel_m.msirinaunutrasnjaizmedjukrilaca, // NJ 2024-11-25: IZBACUJEMO
    mvisinaunutrasnjaizmedjukrilaca: virtel_m.mvisinaunutrasnjaizmedjukrilaca,
  };
  return pods_input_inherited;
};


// TODO cparams_combined uzeti materijale
export const _derivat_terkk_rammraztermostata_izracunaj_materijale = (pods_input, cparams_combined) => {
  /*
  // _default_materijali_v1 sluze da zadrze kompatibilnost sa starim sastavnicama pre cparams
  const _default_materijali_v1 = {
    rmt_materijal_profil: "LB00000J", // LB00000J - LIM POCINKOVANI 1.50 - Kada tip komore nije HYGIENE:pro
    rmtklizac_materijal_lim_pocinkovani: "LC00000J", // LC00000J - LIM PROHROM 1.50 - Kada tip komore jeste HYGIENE:pro
    rmtklizac_materijal_lim_prohrom: "LB00000J", // LB00000J - LIM POCINKOVANI 1.50 - Kada tip komore jeste komore HYDRA:pro
  };
  */
  //
  const tipkomore = pods_input.tipkomore;
  //
  let _cpci = {};
  if (cparams_combined && cparams_combined.terkk_materijal_ident && js_utils.is_object(cparams_combined.terkk_materijal_ident)) { // validate cparams TODO
    // By cparmas
    _cpci = cparams_combined.terkk_materijal_ident;
  }
  //
  let tipmetalalima = "pocinkovani";
  if (tipkomore === "HYGIENE:pro") {
    tipmetalalima = "prohrom";
  } else {
    tipmetalalima = "pocinkovani";
  }
  //
  let rmtklizac_materijal_lim = null;
  if (tipmetalalima === "pocinkovani") {
    rmtklizac_materijal_lim = _cpci.rmtklizac_materijal_lim_pocinkovani;
  }
  if (tipmetalalima === "prohrom") {
    rmtklizac_materijal_lim = _cpci.rmtklizac_materijal_lim_prohrom;
  }
  //
  const rmt_materijal_profil = _cpci.rmt_materijal_profil;
  //
  return {
    tipmetalalima,
    rmt_materijal_profil,
    rmtklizac_materijal_lim,
  };
};


export const _derivat_terkk_rammraztermostata_izracunaj_prvo = (state, pods_input) => {
  //
  const {
    msirinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjukrilaca,
  } = pods_input;
  //
  /*
  rmt_sirinarama predstavlja širinu između krilaca
  rmt_visinarama predstavlja visinu između krilaca - 5 mm
  */
  const rmt_sirinarama = msirinaunutrasnjaizmedjupregradnih;
  const rmt_visinarama = mvisinaunutrasnjaizmedjukrilaca - 5;
  //
  /*
  rmt_tip računa se po sledećoj formuli:
  IF $rmt_sirinarama>1830 AND rmt_visinarama>=910 THEN "TIP C"
  IF $rmt_sirinarama>=1220 AND rmt_visinarama>=910 THEN "TIP B" 
  ELSE "TIP A"
  Tipovi međusobno se razliku po broju srednjeg ojačanja Tip C ima 2 TIPB ima 1 Dok tip A nema nijedno.
  */
  /*
  rmt_b predstavlja razmak između središnjih ojačanja, odnosno kada je samo jedno ojačanje poziciju od ivice rama.
  Poziciju preračunavamo po sledećoj formuli:
  IF TIP A THEN  rmt_sirinarama - (2*20)
  IF TIP B THEN (rmt_sirinarama - (3*20))/2
  IF TIP C THEN (rmt_sirinarama - (4*20))/3
  */
  let rmt_tip = null;
  let rmt_b = null;
  if (rmt_sirinarama > 1830 && (rmt_visinarama > 0 && rmt_visinarama >= 910)) {
    rmt_tip = 'C'; // Tip A nema sredje ojacanje
    rmt_b = ((rmt_sirinarama - (4 * 20)) / 3); // razmak između središnjih ojačanja
  } else if (rmt_sirinarama > 1220 && (rmt_visinarama > 0 && rmt_visinarama >= 910)) {
    rmt_tip = 'B'; // Tip B ima jedno srednje ojacanje
    rmt_b = ((rmt_sirinarama - (3 * 20)) / 2); // poziciju od ivice rama.
  } else {
    rmt_tip = 'A'; // Tip C ima 2 srednja ojacanja
    rmt_b = rmt_sirinarama - (2 * 20); // NJ 2024-09-06: Iako kod tipa A ne postoji srednje ojacanje ta mera postoji na crtezima i ovako se racuna.
  }
  //
  return {
    rmt_sirinarama,
    rmt_visinarama,
    rmt_tip,
    rmt_b,
  };
};


//
export const _derivat_terkk_rmt_pbnode_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 

  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  //
  const {
    tervrstaprofila_50_ili_70,
    rmt_sirinarama,
    rmt_visinarama,
    rmt_tip,
    rmt_b,
  } = protobomp_superdata;
  //
  if (tervrstaprofila_50_ili_70 === "50") {
    _visina_20_ili_35 = 20;
  }
  if (tervrstaprofila_50_ili_70 === "70") {
    _visina_20_ili_35 = 35;
  }
  //

  //
  if (true) {
    // sklop
    if (family === 'terkk$rmt/SKLOP_RMT') { // 1.
      /*
      if (rmt_sirinarama > 1830 && rmt_visinarama >= 910) {
        item.tip = "C"; // DIRTY
      } else if (rmt_sirinarama >= 1220 && rmt_visinarama >= 910) {
        item.tip = "B"; // DIRTY
      } else {
        item.tip = "A"; // DIRTY
      }
      */
      item.tip = rmt_tip; // DIRTY
      item.rmt_sirinarama = rmt_sirinarama; // DIRTY
      item.rmt_visinarama = rmt_visinarama; // DIRTY
      // Naziv: „RAM MRAZ TERMOSTATA-“ $rmt_tip"-"$rmt_sirinarama „X“ $rmt_visinarama
      _naziv = 'RAM MRAZ TERMOSTATA-' + rmt_tip + MINUS + rmt_sirinarama + 'x' + rmt_visinarama;
    }
    // sklop
    if (family === 'terkk$rmtklizac/SKLOP_RMT_KLIZAC') { // 5.
      item.tip = "A"; // DIRTY
      item.tervrstaprofila_50_ili_70 = tervrstaprofila_50_ili_70; // DIRTY
      item.sirina = rmt_sirinarama - 2;
      // Naziv: „KLIZAČ RAM MRAZ TERMOSTATA-“ $rmt_sirinarama -2 "-" $tervrstaprofila_50_ili_70 -MATERIJAL (GS-pocinkovani lim SS-prohromski lim“
      _naziv = 'KLIZAČ RAM MRAZ TERMOSTATA-' + (rmt_sirinarama - 2) + MINUS + tervrstaprofila_50_ili_70 + MINUS + _materijal;
    }
    //
    if (family === 'terkk$rmt/PROFIL_HORIZONTALNI') { // 2.
      // Naziv: „RAM MRAZ TERMOSTATA-HORIZONTALNI PROFIL"- $rmt_sirinarama
      _naziv = 'RAM MRAZ TERMOSTATA-HORIZONTALNI PROFIL-' + item.duzina;

    }
    if (family === 'terkk$rmt/PROFIL_VERTIKALNI') { // 3.
      // Naziv: „RAM MRAZ TERMOSTATA-VERTIKALNII PROFIL"- $rmt_visinarama
      _naziv = 'RAM MRAZ TERMOSTATA-HORIZONTALNI PROFIL-' + item.duzina;

    }
    if (family === 'terkk$rmt/PROFIL_OJACANJA') { // 4.
      // Naziv: „RAM MRAZ TERMOSTATA-PROFIL OJACANJA"- $rmt_visinarama-40
      _naziv = 'RAM MRAZ TERMOSTATA-PROFIL OJACANJA-' + item.duzina;

    }
    //
    if (family === 'terkk$rmtklizac/LIM_OMEGA' || family === 'terkk$rmtklizac/LIM_OMEGA_1_2' || family === 'terkk$rmtklizac/LIM_OMEGA_2_2') { // 6.
      item.tip = "OMEGA"; // DIRTY
      // Naziv: „RAM MRAZ TERMOSTATA-OMEGA KLIZAC"- $rmt_sirinarama-2 "-" H20 ili H35(u zavisnosti od profila P50-P70) -MATERIJAL (GS-pocinkovani lim SS-prohromski lim“
      _naziv = 'RAM MRAZ TERMOSTATA-OMEGA KLIZAC-' + (rmt_sirinarama - 2) + MINUS + 'H' + _visina_20_ili_35 + MINUS + _materijal; // DIRTY
      // item.razvijenamera1 = (rmt_b - 2); // DIRTY // Dužina razvijena: $ramfuk_sirinab-2
      item.razvijenamera1 = (rmt_sirinarama - 2); // DIRTY // Dužina razvijena: $rmt_sirinarama-2 // Izmena 06.11.2024 korišćen je pogrešan parametar
      // Širina razvijena: IF $tervrstaprofila_50_ili_70=50 THEN 83,5 ELSE IF $tervrstaprofila_50_ili_70=70 THEN 123,5
      item.razvijenamera2 = -1;
      if (tervrstaprofila_50_ili_70 === '50') {
        item.razvijenamera2 = 83.5; // DIRTY
      } else if (tervrstaprofila_50_ili_70 === '70') {
        item.razvijenamera2 = 123.5; // DIRTY
      }
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      // CNC crtež: „P01-16-KL-„ H20 ili H35(u zavisnosti od profila P50-P70)"-“ $ramfuk_sirinab-2 „-MATERIJAL (GS-pocinkovani lim SS-prohromski lim“-P1
      _cnc = 'P01-16-KL-H' + _visina_20_ili_35 + MINUS + (rmt_sirinarama - 2) + MINUS + _materijal + '-P1';
      // Napomena: Ukoliko dužina prelazi 2400mm. Ovaj element se proizvodi iz dva dela, onda se dužina deli na pola. CNC program dobija vrednosti P1.1 P1.2
      if (family === 'terkk$rmtklizac/LIM_OMEGA_1_2') {
        // item.ter_koji_deo_visedelnog = 1; // DIRTY
        _naziv += SPACE + "1od2";
        _cnc += '.1'; // SUFIX
        item.ter_koji_deo_visedelnog = 1; // DIRTY
      }
      if (family === 'terkk$rmtklizac/LIM_OMEGA_2_2') {
        _naziv += SPACE + "2od2";
        _cnc += '.2'; // SUFIX
        item.ter_koji_deo_visedelnog = 2; // DIRTY
      }
    }
    if (family === 'terkk$rmtklizac/LIM_U' || family === 'terkk$rmtklizac/LIM_U_1_2' || family === 'terkk$rmtklizac/LIM_U_2_2') { // 7.
      item.tip = "U_PROFIL"; // DIRTY
      // Naziv: „RAM MRAZ TERMOSTATA-U PROFIL"- $rmt_sirinarama-2 -MATERIJAL (GS-pocinkovani lim SS-prohromski lim“
      _naziv = 'RAM MRAZ TERMOSTATA-U PROFIL-' + (rmt_sirinarama - 2) + MINUS + _materijal; // DIRTY
      // item.razvijenamera1 = (rmt_b - 2); // DIRTY // Dužina razvijena: $ramfuk_sirinab-2
      item.razvijenamera1 = (rmt_sirinarama - 2); // DIRTY // Dužina razvijena: $rmt_sirinarama-2 / Izmena 06.11.2024 korišćen je pogrešan parametar
      item.razvijenamera2 = 49.8; // DIRTY // Širina razvijena: 49,8
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      // CNC crtež: „P01-16-KL-„ $ramfuk_sirinab-2 „-MATERIJAL (GS-pocinkovani lim SS-prohromski lim“-"P2"
      _cnc = 'P01-16-KL-' + (rmt_sirinarama - 2) + MINUS + _materijal + '-P2';
      // Napomena: Ukoliko dužina prelazi 2400mm. Ovaj element se proizvodi iz dva dela, onda se dužina deli na pola. CNC program dobija vrednosti P2.1 i P2.2
      if (family === 'terkk$rmtklizac/LIM_U_1_2') {
        _naziv += SPACE + "1od2";
        _cnc += '.1'; // SUFIX
        item.ter_koji_deo_visedelnog = 1; // DIRTY
      }
      if (family === 'terkk$rmtklizac/LIM_U_2_2') {
        _naziv += SPACE + "2od2";
        _cnc += '.2'; // SUFIX
        item.ter_koji_deo_visedelnog = 2; // DIRTY
      }
    }
    if (family === 'terkk$rmt/NOSAC_TERMOSTATA') { // 8.
      // Naziv: „RAM MRAZ TERMOSTATA-NOSAC TERMOSTATA"-MATERIJAL (GS-pocinkovani lim SS-prohromski lim“
      _naziv = 'RAM MRAZ TERMOSTATA-NOSAC TERMOSTATA-' + _materijal;
      item.razvijenamera1 = 168; // DIRTY // Dužina razvijena: 168
      item.razvijenamera2 = 148; // DIRTY // Širina razvijena: 148
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      // CNC crtež: P01-16-NO-03
      _cnc = 'P01-16-NO-03';
    }
    //
  }
  // 
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_rammraztermostata_izracunaj_za_step_protobomp = (state, pods_input) => {
  //
  const {
    ksirinaoznaka, kvisinaoznaka,
    vrstaprofila,
  } = pods_input;
  const {
    kolicina,
    rmt_sirinarama,
    rmt_visinarama,
    rmt_tip,
    rmt_b,

    tipmetalalima,
    rmt_materijal_profil,
    rmtklizac_materijal_lim,
  } = state;
  //
  const rmt_kolicina = kolicina;
  const rmtklizac_kolicina = kolicina * 2; // NJ 2024-09-30: kolicna klizaca treba biti 2 putaveca od rmt kolicine

  const tervrstaprofila_50_ili_70 = _derivatModulProfil_extract_50_ili_70_by_vrstaprofila(vrstaprofila);

  // TODO
  const protobomp_superdata = {
    // tipmetalalima, // TODO ???
    tervrstaprofila_50_ili_70,
    rmt_sirinarama,
    rmt_visinarama,
    rmt_tip,
    rmt_b,
  };

  //
  // _subform_arr
  let _arr = [];
  let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$rmt"), protobomp_superdata);
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_rmt_pbnode_dirty_enrich;
  // ----- kreiranje sklopova
  //
  const _sklop_uzor = {
    jm: tclocal.JM_KOM,
  };
  let _temp_sklop;
  let _temp_pbnode;
  // 1.
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$rmt/SKLOP_RMT',
    naziv: '* RAM MRAZ TERMOSTATA- ???',
    kolicina: rmt_kolicina,
    operacija1: "OPSKL",
    rc1: "GRCFIN",
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_RMT');
  const { created_tempkey: sklop_rmt } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  // 5.
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$rmtklizac/SKLOP_RMT_KLIZAC',
    naziv: '* KLIZAČ RAM MRAZ TERMOSTATA- ???',
    kolicina: rmtklizac_kolicina,
    identmaterijala: rmtklizac_materijal_lim,
    operacija1: "OPSKL",
    // rc1: "GRCFIN",
    rc1: "RCKLI",
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_RMT_KLIZAC');
  const { created_tempkey: sklop_rmtklizac } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  //
  // ----- dodavanje primitivnih u sklopove
  //
  // DELOVI ZA SKLOP RMT
  if (true) {
    // "PROFIL_HORIZONTALNI", "PROFIL_VERTIKALNI", "PROFIL_OJACANJA", "KLIZAC_MRAZ_TERMOSTATA"
    //
    // 2, "PROFIL_HORIZONTALNI"
    if (true) {
      const item = {
        tempkey: 511,
        // tip: 'PROFIL_HORIZONTALNI',
        pbnode_family: 'terkk$rmt/PROFIL_HORIZONTALNI',
        naziv: "? RAM MRAZ TERMOSTATA-HORIZONTALNI PROFIL",
        kolicina: 2, // po komadu sledece operacije
        duzina: rmt_sirinarama,
        leviger: 45,
        desniger: 45,
        identmaterijala: rmt_materijal_profil,
        operacija1: "OPSEC",
        rc1: "RCTP", // RC-TESTERA PETRICI
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_PROFIL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rmt);
    }
    //
    // 3. "PROFIL_VERTIKALNI"
    if (true) {
      const item = {
        tempkey: 511,
        // tip: 'PROFIL_VERTIKALNI',
        pbnode_family: 'terkk$rmt/PROFIL_VERTIKALNI',
        naziv: "? RAM MRAZ TERMOSTATA-VERTIKALNII PROFIL",
        kolicina: 2, // po komadu sledece operacije
        duzina: rmt_visinarama,
        leviger: 45,
        desniger: 45,
        identmaterijala: rmt_materijal_profil,
        operacija1: "OPSEC",
        rc1: "RCTP", // RC-TESTERA PETRICI
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_PROFIL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rmt);
    }
    //
    // 4. "PROFIL_OJACANJA"
    if (rmt_tip === 'B' || rmt_tip === 'C') {
      const item = {
        tempkey: 511,
        // tip: 'PROFIL_OJACANJA',
        pbnode_family: 'terkk$rmt/PROFIL_OJACANJA',
        naziv: "? RAM MRAZ TERMOSTATA-PROFIL OJACANJA",
        duzina: (rmt_visinarama - 40),
        leviger: 90,
        desniger: 90,
        identmaterijala: rmt_materijal_profil,
        operacija1: "OPSEC",
        rc1: "RCTP", // RC-TESTERA PETRICI
      };
      // Količina: $kolicina*((IF TIP B THEN 1 ELSE IF TIP C THEN 2) ELSE 0)
      if (rmt_tip === 'B') {
        item.kolicina = 1;
      } else if (rmt_tip === 'C') {
        item.kolicina = 2;
      } else {
        item.kolicina = 0;
      }
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_PROFIL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rmt);
    }

    // NJ 2024-09-30: Deo NOSAC_TERMOSTATA prebaciti iz sklopa sklop_rmtklizac gore u sklop_rmt i onda ne mora da mu se koriguje količina. (Prvobitno je bio u svrstan tamo jer je od lima a svi ostalo su bili profili u onom sklopu).
    // 8. "NOSAČ TERMOSTATA"    
    if (true) {
      const item = {
        tempkey: 511,
        // tip: 'U_PROFIL',
        pbnode_family: 'terkk$rmt/NOSAC_TERMOSTATA',
        naziv: "? RAM MRAZ TERMOSTATA-NOSAC TERMOSTATA",
        // kolicina: 1, // po komadu sledece operacije
        kolicina: 1, // po komadu sledece operacije // NJ: Količina: 1 (1 komad po sklopu1) // TODO
        identmaterijala: rmtklizac_materijal_lim,
        razvijenamera1: 168, //
        razvijenamera2: 148, //
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rmt);
    }
    //
  }
  //
  // ZATIM DELOVI ZA SKLOP KLIZAC RMT...
  if (true) {
    if (true) {
      // "LIM_OMEGA", "LIM_U"
      //
      // 6. "OMEGA KLIZAC"
      let item_jednodelni;
      const item = {
        tempkey: 511,
        // tip: 'OMEGA_PROFIL',
        pbnode_family: 'terkk$rmtklizac/LIM_OMEGA',
        naziv: "? RAM MRAZ TERMOSTATA-OMEGA KLIZAC",
        kolicina: 1, // po komadu sledece operacije
        identmaterijala: rmtklizac_materijal_lim,
        // razvijenamera1: rmt_b - 2,
        razvijenamera1: rmt_sirinarama - 2, // Dužina razvijena: $rmt_sirinarama-2 // Izmena 06.11.2024 korišćen je pogrešan parametar
        razvijenamera2: -1, // bice izracunata u enrich
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      item_jednodelni = item;
      // Napomena: Ukoliko dužina prelazi 2400mm. Ovaj element se proizvodi iz dva dela, onda se dužina deli na pola. CNC program dobija vrednosti P1.1 P1.2
      // NJ 2024-10-22: Ovi elementi su simetrični tako da nije potrebno .1 i .2. Već samo da se dužine podele /2 i količine uvećaju za 1.
      // PREPOLOVLJAVANJE MEHANIZAM sa prostim deljenjem na pola i dupliranjem kolicine
      // let ter_visedelni_koliko_delova = null; // NE KORISTI SE
      if (item_jednodelni.razvijenamera1 > 2440) { // PREPOLOVLJAVANJE MEHANIZAM CASE dve iste polovine
        // ter_visedelni_koliko_delova = 2; // NE KORISTI SE
        const _prepolovljena_duzina = ROUNDDOWN(item.razvijenamera1 / 2); // NJ 2024-04-09: Kada delimo elemente na pola, kao što je pomenuto u prethodnoj stavci, potrebno je novu dimenziju zaokružiti na broj manje
        // item.naziv = 
        // pbnode_family: 'terkk$rmtklizac/LIM_OMEGA_1_2',
        item.razvijenamera1 = _prepolovljena_duzina;
        item.kolicina = item_jednodelni.kolicina * 2; // kolicina za 2 ista dela se uduplava
        item.ter_koji_deo_visedelnog = '1/2'; //
      }
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rmtklizac);
    }
    //
    // 7. "OMEGA_PROFIL"
    if (true) {
      let item_jednodelni;
      const item = {
        tempkey: 511,
        // tip: 'U_PROFIL',
        pbnode_family: 'terkk$rmtklizac/LIM_U',
        naziv: "? RAM MRAZ TERMOSTATA-U PROFIL",
        kolicina: 1, // po komadu sledece operacije
        // razvijenamera1: rmt_b - 2,
        razvijenamera1: rmt_sirinarama - 2, // Dužina razvijena: $rmt_sirinarama-2 / Izmena 06.11.2024 korišćen je pogrešan parametar
        razvijenamera2: 49.8, //
        identmaterijala: rmtklizac_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      item_jednodelni = item;
      // Napomena: Ukoliko dužina prelazi 2400mm. Ovaj element se proizvodi iz dva dela, onda se dužina deli na pola. CNC program dobija vrednosti P2.1 i P2.2
      // PREPOLOVLJAVANJE MEHANIZAM sa prostim deljenjem na pola i dupliranjem kolicine
      let ter_visedelni_koliko_delova = null;
      if (item_jednodelni.razvijenamera1 > 2440) { // PREPOLOVLJAVANJE MEHANIZAM CASE dve iste polovine
        ter_visedelni_koliko_delova = 2; // NE KORISTI SE
        const _prepolovljena_duzina = ROUNDDOWN(item.razvijenamera1 / 2); // NJ 2024-04-09: Kada delimo elemente na pola, kao što je pomenuto u prethodnoj stavci, potrebno je novu dimenziju zaokružiti na broj manje
        // item.naziv = 
        // pbnode_family: 'terkk$rmtklizac/LIM_OMEGA_1_2',
        item.razvijenamera1 = _prepolovljena_duzina;
        item.kolicina = item_jednodelni.kolicina * 2; // kolicina za 2 ista dela se uduplava
        item.ter_koji_deo_visedelnog = '1/2'; //
      }
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rmtklizac);
    }

  }
  //
  //
  return {
    svasta: {
      tervrstaprofila_50_ili_70,
    },
    _arr,
    _protobomp,
  }; // TODO
};


// ---------- VIRBOM DERIVATS ----------


export const derAutoCreateVirbom_terkk_rammraztermostata_prepare_vir_input = (p) => {
  // TODO
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const v_input = {
    p: p,


  };
  return v_input;
};


export const derAutoCreateVirbom_terkk_rammraztermostata_children = (v_input) => {
  console.log('derAutoCreateVirbom_terkk_rammraztermostata_children(v_input) ');
  console.log(v_input);

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};

